var ESCAPE = '#';

// The file that will 'translate' all the constants to proper strings.
var strings = {
  // Common errors
  null: 'Inválido',
  error_403: 'Conteúdo não encontrado.',
  error_500: 'Oops! O sistema não conseguiu realizar sua operação.',
  error__invalid_date_from: 'A data (DE) selecionada não é válida.',
  error__invalid_date_to: 'A data (PARA) selecionada não é válida.',
  error__date_from_after_date_to: 'A data (DE) não pode ser depois da data (PARA).',
  error__invalid_cnpj: 'O CNPJ provido não é válido.',
  error__cnpj_already_exists: 'O CNPJ provido já existe.',
  error__invalid_name: 'O nome não é valido.',
  error__invalid_email: 'O e-mail digitado não é válido.',
  error__invalid_prescription: 'A prescrição não é válida.',
  error__invalid_number_of_cylinders: 'O número de cilindros não é válido.',
  error__invalid_supplier_client: 'O fornecedor não é válido.',
  // Monitor
  monitor__restitution: 'Não foi possível atualizar o cilindro.',
  // Patient
  patient_period_type_0: 'Se necessário',
  patient_period_type_1: 'Uso contínuo',
  patient_period_type_short_0: 'SN',
  patient_period_type_short_1: 'UC',
  patient_status_0: 'Novo',
  patient_status_1: 'Ativo',
  patient_status_2: 'Inativo',
  patient__invalid_period_type: 'O tipo de uso não é válido.',
  patient__invalid_cpf: 'O CPF informado não é válido.',
  patient__cpf_already_exists: 'Já existe um paciente cadastrado com esse CPF.',
  patient__rg_already_exists: 'Já existe um paciente cadastrado com esse RG.',
  patient__invalid_address_number: 'O número de endereço é invalido',
  patient_deinit__patient_uninitialized: 'Não é possível desativar um paciente que não foi inicializado.',
  patient_deinit__invalid_cylinder_quantity: 'O número de cilindros lacrados é maior do que o número de cilindros cheios.',
  patient_init__patient_active: 'Não é possível inicializar um paciente que já está ativo.',
  patient_init__invalid_empty_cylinder: 'Número de cilindros vazio inválido.',
  patient_init__invalid_full_cylinder: 'Número de cilindros cheios inválido.',
  error_404_patient: 'O paciente solicitado não existe',
  patient_not_selected: 'Selecione um paciente para gerar o relatório.',
  // Replacement
  error_404_replacement: 'A requisição de entrega não existe.',
  // Client
  client_type_0: 'Salvus',
  client_type_1: 'Homecare',
  client_type_2: 'Hospital',
  client_status_0: 'Novo',
  client_status_1: 'Ativo',
  client_status_2: 'Inativo',
  client__invalid_type: 'Tipo do cliente não é válido.',
  client__invalid_name: 'O nome do cliente não é válido.',
  client_update__forbidden_change_type: 'Não é possível alterar o tipo deste cliente.',
  client_update_status__forbidden_change_status: 'Não é possível alterar o status deste cliente.',
  error_404_client: 'O cliente solicitado não existe',
  // Account
  account_profile_1: 'Usuário',
  account_profile_9: 'Administrador',
  account__invalid_profile: 'O perfil do operador não é válido.',
  account__email_already_exists: 'Já existe um operador cadastrado com esse e-mail.',
  account__invalid_password: 'A senha digitada é muito fraca.',
  account_remove__cannot_remove_yourself: 'Você não pode deletar sua própria conta.',
  error_404_account: 'O usuário solicitado não existe',
  // Device
  device_status_0: 'Não Vinculado',
  device_status_1: 'Vinculado',
  device_type_1: 'Neonatal',
  device_type_2: 'Adulto',
  device_type_3: 'Ventilador Pulmonar',
  device_type_4: 'Alto Fluxo',
  device_type_5: 'Concentrador',
  device_type_6: 'Sinais Vitais',
  device__invalid_key: 'A chave digitada é inválida.',
  device__key_already_exists: 'Já existe um device cadastrado com essa chave.',
  device_update__change_client_with_patient: 'Não é possível mudar o cliente enquanto ele está vinculado a um paciente.',
  device_update__patient_already_has_device: 'Não é possível atribuir um device para um paciente que já possui um device.',
  device_update__patient_initialized: 'Não é possível atualizar o paciente de um device, quando o paciente atual está ativo.',
  device_remove__device_with_patient: 'Não é possível remover o device enquanto ele está vinculado a um paciente.',
  error_404_device: 'O device solicitado não existe',
  // Supplier
  supplier_create__invalid_client: 'O cliente não é valido.',
  error_404_supplier: 'O fornecedor solicitado não existe',
  supplier_not_selected: 'Selecione um fornecedor para gerar o relatório.',
  // Delivery
  delivery_save_pending__invalid_cylinder_qtd_requested: 'Por favor, verifique as quantidades de cilindros de cada solicitação.',
  delivery_save_pending__incomplete: 'Não foi possível enviar todos os e-mails de solicitação. Verifique as operações abaixo.',
  delivery_confirm_pending__empty_array: 'Você deve confirmar algum paciente para realizar a solicitação.',
  delivery_edit_confirm__not_last_delivery: 'Não foi possível realizar a operação, só é possível alterar a última confirmação.',
  delivery_edit_confirm__insufficient_cylinders: 'Não foi possível realizar a operação, o paciente não possui cilindros cheios suficientes.',
  delivery_edit_confirm__request_more_than_max: 'Não foi possível realizar a operação, a quantidade requisitada é maior que a maxima.',
  // Cylinder
  cylinder_update__invalid_cylinder_state: 'O estado do cilindro não é válido.',
  cylinder_update__invalid_updatedAt: 'A data de atualização do cilindro não é válida.',
  cylinder_update__invalid_patient: 'O paciente não existe.',
  error_404_cylinder: 'O cilindro solicitado não existe'
};

/**
 * Function that should check if the key has a proper translation.
 * - If there are not translation avaible return the key.
 */
module.exports = function (key, data) {
  key = key === null ? '' : key.toLowerCase();
  var message = strings[key] || key;
  if (data) {
    var keys = Object.keys(data);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var str = '' + ESCAPE + '' + k;
      message = message.replace(str, data[k]);
    }
  }
  return message;
};